<template>
<section id="home">
<div class="contain"  >
  <div class="row homer align-items-center no-gutters" >
    <div class="col-12 col-lg-12">
      
      <div class="home_content" style="color:white;">
      <h1 class="hi" >Hi, <span style="color:white;">my name is</span></h1>
      <p class="name">Damanpreet Kaur</p>
      <div class="text_animate">
        I build with <vue-typer
  :text='["Perfection", "Creativity", "Simplicity"]'
  :repeat='Infinity'
  :shuffle='false'
  initial-action='typing'
  :pre-type-delay='70'
  :type-delay='70'
  :pre-erase-delay='2000'
  :erase-delay='70'
  erase-style='backspace'
  :erase-on-complete='false'
  caret-animation='smooth'
></vue-typer>
       
        
 </div> 
 
   
      <div class="col-10 col-sm-10 col-md-8 col-lg-6 intro justify-content" style="margin-bottom:0rem">I am a Full Stack Developer based in Toronto, Ontario with a crazy passion for exploration and continual learning.
        I find happiness in being a better me today than the me yesterday.
      </div>

      </div>
    </div>
</div>
</div>


  <section id="about">
    <About></About>
  </section>

  <section id="skills">
    <Skills></Skills>
  </section>

  <section id="experience">
    <Experience></Experience>
  </section>

<section id="projects">
    <Projects></Projects>
  </section>

  <section id="contact">
    <Contact></Contact>
  </section>

<section id="footer">
    <Footer></Footer>
  </section>


</section>
 
</template>
<script>
import About from './About.vue'
import Skills from './Skills.vue'
import Experience from './Experience.vue'
import Projects from './Projects.vue'
import Contact from './Contact.vue'
import Footer from './Footer.vue'
export default {
  components: {
    About,
    Skills,
    Experience,
    Projects,
    Contact,
    Footer
  }
}


</script>
<style >
#home{
  display:none;
}
.homer{
 
height:100vh;
  width:100%;
  margin:0;
  padding:0;
  box-sizing:border-box;
 
}
.hi{
  color:#FF033E;
  font-size: 20px;
 margin-top:3rem;
font-family: 'Source Sans Pro', sans-serif;
  margin-left: 69px;

}
.name{
  font-size:75px;
  margin-left: 65px;
  color:white;
  font-family: 'Merriweather Sans', sans-serif;

}
.intro{
  color:white;
font-family: 'Source Sans Pro', sans-serif;
 letter-spacing:0.5px;
 font-size:20px;
 margin-left: 60px;
 margin-top:30px;
 text-align:justify;
 font-weight:500;
}
.text_animate{
  color:white;
  font-size:55px;
  margin-left: 70px;
  font-family: 'Merriweather Sans', sans-serif;
}

@keyframes rocking {
  0%,100% {transform: rotateZ(-10deg);}
  50%     {transform: rotateZ(10deg);}
}

.vue-typer {
  font-family: 'Merriweather Sans', sans-serif;
}
.vue-typer .custom.char.typed {
  color: #FF033E;
}
.vue-typer .custom.char.selected {
  color: white;
  
}

.vue-typer .custom.caret {
  animation: rocking 1s ease-in-out 0s infinite;
}
.vue-typer .custom.caret.typing {
  background-color:white;

}

@media screen and (min-width:1400px){
  .hi{
  color:#FF033E;
  font-size: 30px;
  
  font-family: 'Source Sans Pro', sans-serif;
  margin-left: 100px;

}
.name{
  font-size:105px;
  margin-left: 100px;
  color:white;
  font-family: 'Merriweather Sans', sans-serif;
}
.text_animate{
  color:white;
  font-size:85px;
  margin-left: 100px;
  font-family: 'Merriweather Sans', sans-serif;
}
.intro{
  color:white;
  font-family: 'Source Sans Pro', sans-serif;
  letter-spacing:0.5px;
 font-size:25px;
 margin-left: 100px;
 margin-top:70px;
}

}



@media screen and (max-width:567px){
  

   .hi{
  color:#FF033E;
  font-size: 16px;
 margin-top:2rem;
  font-family: 'Source Sans Pro', sans-serif;
  margin-left: 20px;

}
.name{
  font-size:35px;
  margin-left: 20px;
  color:white;
  font-family: 'Merriweather Sans', sans-serif;
}
.text_animate{
  color:white;
  font-size:25px;
  margin-left: 20px;
  font-family: 'Merriweather Sans', sans-serif;
}
.intro{
  color:white;
  font-family: 'Source Sans Pro', sans-serif;
  letter-spacing:0.5px;
 font-size:17px;
 margin-left: 8px;
 margin-top:50px;
}



}
@media screen and (min-width: 568px) and (max-width: 767px)  {
     
     
  .name{
  font-size:55px;
  margin-left: 40px;
  color:white;
  font-family: 'Merriweather Sans', sans-serif;
}
  .hi{
   
    font-size: 25px;
     margin-left: 40px;
     font-family: 'Source Sans Pro', sans-serif;

  }
  
.intro{
  color:white;
 font-family: 'Source Sans Pro', sans-serif;
 font-size:20px;
 letter-spacing:0.5px;
 margin-left: 30px;
 margin-top:70px;
}

.text_animate{
  color:white;
  font-size:35px;
  margin-left: 40px;
  
  font-family: 'Merriweather Sans', sans-serif;
}
    }
@media screen and (min-width: 768px)and (max-width:1000px){
  .name{
  font-size:60px;
  margin-left: 50px;
  color:white;
  font-family: 'Merriweather Sans', sans-serif;
}
  .hi{
   
    font-size: 25px;
     margin-left: 50px;
     font-family: 'Source Sans Pro', sans-serif;

  }
  
.intro{
  color:white;
 font-family: 'Source Sans Pro', sans-serif;
 font-size:20px;
 letter-spacing:0.5px;
 margin-left:40px;
 margin-top:70px;
}

.text_animate{
  color:white;
  font-size:35px;
  margin-left: 50px;
  
  font-family: 'Merriweather Sans', sans-serif;
}
}


</style>